import React, {useEffect, useMemo, useState} from 'react';

import Dropdown from 'brandComponents/Dropdown';
import {EDropdownDirection} from 'brandComponents/Dropdown/IDropdown';
import Field from 'brandComponents/Form/Subcomponents/Field';
import Icon from 'brandComponents/Icon';

import {IReasonDropdownProps} from './IReasonDropdown';

const ReasonDropdown = ({
	itemKey,
	reasons,
	reasonSelected,
	setReasonSelected,
	fieldName
}: IReasonDropdownProps) => {
	const getInitialReasons = (reasons) => {
		const label = reasons[0]?.getLabel();
		const value = reasons[0]?.getValue();

		return {label, value};
	};

	const [selectedLabel, setSelectedLabel] = useState(getInitialReasons(reasons).label);

	const data = useMemo(() => {
		return reasons.map((reason) => {
			return {
				label: reason.getLabel(),
				value: reason.getValue(),
			};
		});
	}, [reasons]);

	useEffect(() => {
		const value = reasonSelected[itemKey];

		setSelectedLabel(
			value
				? reasons.find(r => r.getValue() === value).getLabel()
				: getInitialReasons(reasons).label
		);
	}, [reasons, itemKey, reasonSelected]);

	return (
		<React.Fragment key={fieldName}>
			<Dropdown
				label={getInitialReasons(reasons).label}
				value={selectedLabel || getInitialReasons(reasons).label}
				classNames={'return-create-step-1__select'}
				direction={EDropdownDirection.DYNAMIC}
			>
				<Dropdown.Trigger
					customIcon={<Icon name="arrow-down" width={16} height={16} />}
				/>
				<Dropdown.Menu
					data={data}
					onSelect={(value) => {
						setReasonSelected({
							...reasonSelected,
							[itemKey]: value,
						});
					}}
				/>
			</Dropdown>
			<Field
				name={`${fieldName}-${itemKey}`}
				component="input"
				type="hidden"
				initialValue={
					reasonSelected[itemKey] || getInitialReasons(reasons).value
				}
			/>
		</React.Fragment>
	);
};

export default ReasonDropdown;